import { render, staticRenderFns } from "./AdvanceRegistration.vue?vue&type=template&id=2f8598a3"
import script from "./AdvanceRegistration.vue?vue&type=script&lang=ts"
export * from "./AdvanceRegistration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports